import Vue from 'vue';
import Vuex from 'vuex';
import um from './module/um';
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        um: um,
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/store/index.ts
// module id = null
// module chunks = 